import { FetchRequest } from '../global/services/request'

export class HttpError extends Error {
  public httpStatus: number
  public errorCode: string
  public message: string
  public request: FetchRequest

  constructor(httpStatus: number, errorCode: string, message: string, request: FetchRequest) {
    super()
    this.errorCode = errorCode
    this.httpStatus = httpStatus
    this.message = message
    this.request = request
  }
}

export class ActionError extends Error {
  public originalError: Error
  public action: string

  constructor(action: string, originalError: Error) {
    super()
    this.originalError = originalError
    this.action = action
  }
}
